import React from 'react';
import MediaCard, { MediaCardProps } from '../MediaCard/MediaCard';
import LeftAlignedCarousel from 'molecules/LeftAlignedCarousel/LeftAlignedCarousel';

interface MediaCardCarouselProps {
  cards: MediaCardProps[];
}

const MediaCardCarousel = ({ cards }: MediaCardCarouselProps): JSX.Element => {
  return (
    <LeftAlignedCarousel>
      {cards.map((card, index) => (
        <MediaCard
          key={index}
          {...card}
        />
      ))}
    </LeftAlignedCarousel>
  );
};

export default MediaCardCarousel;
